export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'I coach a high school varsity program and a club team, so my Sunday nights used to disappear into practice plans. Now I open the Ready-to-Coach system, pick the objective from Saturday’s match, and I have a 90-minute session with timing and coaching points in about ten minutes. My practices are sharper and my side-out numbers finally moved.',
    author: 'Michael Doyle',
    role: 'Varsity & Club Head Coach, 44',
    location: 'Columbus, Ohio, United States',
  },
  {
    text: 'The Match Problem → Practice Solution module is what sold me. Our block-defense connection was late all pre-season. I found the problem, followed the priorities and progressions, and after three weeks of that work our opponents’ attack efficiency dropped noticeably. It is the first resource that actually tells me what to fix first.',
    author: 'Sarah Whitfield',
    role: 'Women’s Regional League Coach, 37',
    location: 'Manchester, United Kingdom',
  },
  {
    text: 'I run a club with four age groups and two assistant coaches. The planning frameworks and rotation cards gave us one shared language, so my assistants can now run a session exactly the way I would. The tryout system alone saved us an entire weekend of arguing over the roster.',
    author: 'David Laframboise',
    role: 'Club Director & U18 Coach, 51',
    location: 'Toronto, Ontario, Canada',
  },
  {
    text: 'What I appreciate most is that the drills come with objectives, common errors and success criteria. I stopped running exercises just to keep everyone busy. My players notice the difference too — every drill now has a reason and they know what winning it looks like.',
    author: 'Emma Callaghan',
    role: 'State League Assistant Coach, 29',
    location: 'Brisbane, Queensland, Australia',
  },
  {
    text: 'After twenty-two years coaching I did not expect to need a system like this. But the season structure and weekly models cut my preparation from six or seven hours a week to under two, and the player evaluation trackers made my end-of-season meetings with parents far easier to defend. Best twenty-seven dollars I have spent on my coaching.',
    author: 'Robert Jensen',
    role: 'Collegiate Assistant Coach, 58',
    location: 'Denver, Colorado, United States',
  },
]
